namespace Ir.Components.Filters.WeekFilter {

    interface IViewModel {
        filter: Filter;
        numberBoxSettings: DevExpress.ui.dxNumberBox.Properties;
        numberBoxComponent: DevExpress.ui.dxNumberBox;
        nullButtonParams: Ir.Components.Filters.NullButton.INullButtonParams;
    }

    export function getViewModel(this: IViewModel, params: IFilterParameterVM) {
        let self = this;
        this.filter = params.filter;

        this.filter.startDisplayCondition(this.filter.startCondition() === null ? irSettings.nullText : `Week ${this.filter.startCondition()}`);
        this.numberBoxSettings = {
            disabled: ko.computed(function () {
                return self.filter.readOnly();
            }) as any,
            value: this.filter.startCondition as any,
            showSpinButtons: isMobile() ? false : true,
            valueChangeEvent: "keyup",
            min: 1,
            max: 53,
            format(value) {
                return `Week ${value}`;
            },
            onInitialized(e) {
                self.numberBoxComponent = e.component;
            },
            onValueChanged(data) {
                if (data.value !== null && data.previousValue !== data.value) {
                    let value = data.value !== null && data.value !== undefined ? data.value : "1";
                    self.filter.startCondition(value)
                    self.filter.startDisplayCondition(`Week ${value}`);
                    self.filter.publish();
                }
            }
        };

        this.nullButtonParams = {
            filter: this.filter,
            onItemClick(e) {
                if (self.filter.startCondition() === null) {
                    self.filter.startCondition("1");
                }
                else {
                    self.filter.startCondition(null);
                    self.filter.startDisplayCondition(irSettings.nullText);
                }

                self.filter.publish();
                self.numberBoxComponent.element().focus();
            }
        };
    }
}